import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseDeletePublicCompanyLeadContractEquipmentCategory {
  publicCompanyLeadId?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useDeletePublicCompanyLeadContractEquipmentCategory = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseDeletePublicCompanyLeadContractEquipmentCategory) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deletePublicCompanyLeadEquipmentCategory'],
    mutationFn: async (id: string) => {
      const lead = {
        contract_attributes: {
          contract_equipment_categories_attributes: [
            {
              id,
              _destroy: true,
            },
          ],
        },
      }

      await privateAxios.putForm(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
